import React from "react";
import { Box, IconButton, Tooltip } from "@material-ui/core";
import { SendOutlined } from "@material-ui/icons";
import { useStyles } from "./styles";
import TextFieldInput from "./TextFieldInput";
import { LoadingWidget } from "Components/index";

const ComposeMsg = ({ loading, commentText }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box
        px={2}
        py={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <TextFieldInput commentText={commentText} />
        <IconButton
          size="small"
          aria-label="send message"
          type="submit"
          disabled={!commentText.length || loading}
          className={classes.sendBtn}
        >
          {loading ? (
            <LoadingWidget color="grey" />
          ) : (
            <Tooltip title="Send">
              <SendOutlined
                className="rotate-icon"
                color="primary"
                fontSize="small"
              />
            </Tooltip>
          )}
        </IconButton>
      </Box>
    </div>
  );
};

export default ComposeMsg;
